"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulingFormulaParamDecoder = exports.SchedulingFormulaParamEncoder = void 0;
const lodash_1 = require("lodash");
class SchedulingFormulaParamEncoder {
    static encode(param) {
        if ((0, lodash_1.isUndefined)(param)) {
            return '';
        }
        // [['wombat', 'kazuya'], ['coara', 'rika']]
        // => ['wombat&kazuya', 'coara&rika']
        const andJoined = param.map((andParam) => andParam.join('&'));
        // ['wombat&kazuya', 'coara&rika']
        // wombat&kazuya|coara&rika
        return andJoined.join('|');
    }
}
exports.SchedulingFormulaParamEncoder = SchedulingFormulaParamEncoder;
class SchedulingFormulaParamDecoder {
    static decode(formula) {
        if ((0, lodash_1.isEmpty)(formula)) {
            return undefined;
        }
        // |が%7CになるのでDecodeする
        const URIDecodedFormula = decodeURIComponent(formula);
        // wombat&kazuya|coara&rika
        // => ['wombat&kazuya', 'coara&rika']
        const orSplitted = URIDecodedFormula.split('|');
        // ['wombat&kazuya', 'coara&rika']
        // => [['wombat', 'kazuya'], ['coara', 'rika']]
        const andSplitted = orSplitted.map((os) => os.split('&'));
        return andSplitted;
    }
}
exports.SchedulingFormulaParamDecoder = SchedulingFormulaParamDecoder;
//# sourceMappingURL=schedulingFormulaParamCoder.js.map